export const isAlly = () => {
  try {
    return sessionStorage.getItem("rotu_theme") === "ally";
  } catch (e) {
    return false;
  }
};

export const setAlly = (on) => {
  try {
    if (on) sessionStorage.setItem("rotu_theme", "ally");
    else sessionStorage.removeItem("rotu_theme");
  } catch (e) {}
  window.dispatchEvent(new CustomEvent("rotu:theme", { detail: { ally: on } }));
};
